<template>
  <div>
    <b-row>
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Update"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>

           

        

            <form-group label="Full Name" :required="true">
              <input
                ref="name"
                type="text"
                @blur="$v.user.name.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.user.name.$error }"
                v-model="user.name"
              />
              <div class="invalid-feedback" v-if="!$v.user.name.required">
                Please enter full name
              </div>
            </form-group>

            <form-group label="Email" :required="true">
              <input
                type="email"
                class="form-control"
                :class="{ 'is-invalid': $v.user.email.$error }"
                v-model="user.email"
              />
              <div class="invalid-feedback" v-if="!$v.user.email.required">
                Please enter email address
              </div>
              <div class="invalid-feedback" v-if="!$v.user.email.email">
                invalid email address
              </div>
            </form-group>

               <form-group label="Clocking ID">
              <small class="text-muted">TimeTattler Employee ID</small>
              <input
                type="number"
                min="1"
                class="form-control"
                v-model="user.clocking_system_id"
              />
            </form-group>


              <form-group label="Branch" >
                <small class="text-muted">Required for clockings</small>
              <b-form-select              
                v-model="user.branch_id"
                :options="branches"
                text-field="name"
                value-field="id"
              />
              
            </form-group>


            <form-group label="User roles" :required="true">
              <table class="table table-sm">
                <tr v-for="item in roles" :key="item.id">
                  <td class="border-0">
                    <b-form-checkbox v-model="user.roles" :value="item.id">
                      <span class="text-body">{{ item.role }}</span>
                    </b-form-checkbox>

                    <b-collapse v-model="visibleRoles">
                      <div class="card border p-3">
                        <ul class="list-unstyled">
                          <li
                            class="nav-item"
                            v-for="permission in item.permissions"
                            :key="permission.id"
                          >
                            - {{ permission.permission }}
                          </li>
                        </ul>
                      </div>
                    </b-collapse>
                  </td>
                  <td class="border-0 text-right">
                    <i class="lni lni-search-alt text-primary mt-2" @click="visibleRoles = !visibleRoles"></i>
                  </td>
                </tr>
              </table>

              <div class="text-danger" v-if="$v.user.roles.$error">
                Please select roles
              </div>
            </form-group>
          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import userRepo from "@/api/repos/userRepo";
import { required, email,requiredIf } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";
import roleRepo from "@/api/repos/roleRepo";

export default {
  components: {
    formBase,
    formGroup,
  },
  computed: {},

  mounted() {
    this.$refs.name.focus();
    this.getRoles();
    this.getCreatedData();
    this.getUser();
  },

  validations: {
    user: {
     
      name: {
        required,
      },
      email: {
        required,
        email,
      },
     
      roles: {
        required:requiredIf(function(user) {
            return user.capacity == 'Staff';
        })
      },
      
     
    },
  },

  data() {
    return {
        branches: [],
      visibleRoles: false,
      user: { image_id: null, roles: [],partners:[] },
      roles: [],
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
    };
  },

  props:['id'],

  methods: {
     async getCreatedData() {
      try {
        this.loading = true;
        let { data } = await userRepo.createRelatedData();
        this.branches = data.branches;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
     async getUser() {
      try {
        this.loading = true;
        let { data } = await userRepo.get(this.id);
        this.user = data.user;
        this.user.roles = this.user.roles.map((x) => x.id);
        this.user.partners = this.user.partners.map((x) => x.id);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getRoles() {
      try {
        let { data } = await roleRepo.roles(1, 1000, "role", "asc", "");
        this.roles = data.roles.data;
      } catch (error) {
        console.log(error);
      }
    },
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid || this.imageUploading) {
        if (this.imageUploading) alert("images uploading...");
        this.submitStatus = "ERROR";
        this.loading = false;
      } else {
        try {
          await userRepo.update(this.id,this.user);
          this.$emit("userCreated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }else{
            this.$root.$bvToast.toast("Something Went Wrong", {
              title: error.response.data.message,
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>

<style></style>
